import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {LabelsFilterModal} from "./LabelsFilterModal";
import { withTranslation } from 'react-i18next';

class LabelsFilterButtonComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.closeModal = this.closeModal.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    closeModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleClick(event) {
        event.preventDefault();
        this.setState({
            modal: true
        });
    }

    // rendering

    renderModal() {
        if (this.state.modal) {
            return <LabelsFilterModal
                isOpen={this.state.modal} onClose={this.closeModal}
                onApplyFilter={this.props.onApplyFilter}
                selectedLabels={this.props.selectedLabels}
            />;
        } else {
            return null;
        }
    }

    renderButton() {
        const { t } = this.props;
        return (
            <button onClick={this.handleClick} className="dashboard-header-option">
                <FaIcon iconName="tags"/>
                <p className="header-option-label">{t('dashboard.labels')}</p>
            </button>
        )
    }

    render() {
        return (
            <div className="filter-input">
                {this.renderButton()}
                {this.renderModal()}
            </div>
        );
    }
}

export const LabelsFilterButton = withTranslation()(LabelsFilterButtonComponent);

